<template>
    <div>
        <CollapseConfirmData
            :code-id="code"
            @removeService="removeService"
        >
            <template #content>
                <ChangeBeforeAfter>
                    <template #before>
                        <span>{{ data?.before.apply }}</span>
                    </template>
                    <template #after>
                        <span>{{ data?.after.apply }}</span>
                        <div v-if="data?.email">
                            <p class="break-all">
                                電子通知單將發送至要保人E-mail：{{ data.email }}
                            </p>
                            <p class="text-tip -ml-4">
                                ※ 電子信箱將一併更新至以您為要保人所投保之所有個人險有效及停效保單。
                                <!-- ※ 電子信箱將一併更新至以您為要保人所投保之所有個人險(含MG系列保單)有效及停效保單。 -->
                            </p>
                        </div>
                    </template>
                </ChangeBeforeAfter>
            </template>
        </CollapseConfirmData>
    </div>
</template>

<script>
import { ref, toRef } from 'vue';
import CollapseConfirmData from '@/components/collapse/CollapseConfirmData.vue';
import ChangeBeforeAfter from '@/components/template/ChangeBeforeAfter.vue';

export default {
    name: 'B4Data',
    components: {
        CollapseConfirmData,
        ChangeBeforeAfter
    },
    props: {
        result: {
            type: Object,
            required: true,
        }
    },
    emits: ['removeService'],
    setup(props, { emit }) {
        const data = toRef(props, 'result');
        const code = ref('B4');
        const removeService = () => {
            emit('removeService', code.value);
        };
        return { code, data, removeService };
    },
};
</script>
